import React from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { ExamplesSection } from '../components/ExamplesSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { BusinessTypesSection } from '../components/BusinessTypesSection';
import { OfferSection } from '../components/OfferSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FinalCtaSection } from '../components/FinalCtaSection';
import { FaqSection } from '../components/FaqSection';
import { Footer } from '../components/Footer';
import { WhatsAppButton } from '../components/WhatsAppButton';
export function LandingPage() {
  return <div className="min-h-screen bg-light font-inter selection:bg-primary/30" data-id="element-191">
      <Navbar data-id="element-192" />
      <main data-id="element-193">
        <HeroSection data-id="element-194" />
        <ProblemSection data-id="element-195" />
        <SolutionSection data-id="element-196" />
        <BenefitsSection data-id="element-197" />
        <ExamplesSection data-id="element-198" />
        <TestimonialsSection data-id="element-199" />
        <BusinessTypesSection data-id="element-200" />
        <OfferSection data-id="element-201" />
        <GuaranteeSection data-id="element-202" />
        <FinalCtaSection data-id="element-203" />
        <FaqSection data-id="element-204" />
      </main>
      <Footer data-id="element-205" />
      <WhatsAppButton data-id="element-206" />
    </div>;
}